module.exports = __webpack_public_path__ + "static/img/conmicarano-2.d77e8c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/conmicarano-2.jpg
// module id = v07a
// module chunks = 1